import { render, staticRenderFns } from "./LastTicketsBetItem.vue?vue&type=template&id=040a1594"
import script from "./LastTicketsBetItem.vue?vue&type=script&lang=js"
export * from "./LastTicketsBetItem.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsBetItem.vue?vue&type=style&index=0&id=040a1594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports